import { orderBy } from '@/helper/lodashHelper';

const getViewArea = function (state, area) {
  let foundArea = [];

  // TODO: Would be better if we had for each item a contentType in the metadata
  const fallback = {
    DetailMain: 'detail',
  };

  Object.keys(state.viewAreas).some((viewArea) => {
    if (viewArea.search(area) !== -1) {
      foundArea = state.viewAreas[viewArea];
      return true;
    }
    return false;
  });

  return foundArea.map((tab) => {
    if (!tab.contentType) tab.contentType = fallback[area];
    return tab;
  });
};

const getDefaultObject = function (state, ObjectArray) {
  if (Array.isArray(ObjectArray)) {
    if (ObjectArray.length > 0) {
      const defaultObject = ObjectArray.find((object) => object.FLAGDEFAULT);
      if (defaultObject && defaultObject.length === 1) {
        return defaultObject;
      }
    }
    return ObjectArray[0] || {};
  }
  return ObjectArray;
};

const getAreaField = (state, field) => {
  const areFieldWithRecordBind = state.areaFields.find(
    ({ fieldBind, recordBind }) =>
      fieldBind === field.fieldBind && recordBind === field.recordBind,
  );

  return (
    areFieldWithRecordBind ||
    state.areaFields.find(({ fieldBind }) => fieldBind === field.fieldBind)
  );
};

const getList = function (state, listType, altShape) {
  const listConfig = Object.entries(state.lists)
    .filter(([key]) => key.includes(listType || 'General'))
    .map(([, value]) => value);

  let list = listConfig[0];

  if (!list) return {};

  const path =
    altShape && list[altShape.toLowerCase()]
      ? altShape.toLowerCase()
      : 'default';

  list = list[path] || list;

  return { ...list, columns: orderBy(list.columns, 'position') };
};

const getGrouping = function (state, altShape = 'default') {
  const { grouping = [] } = state;

  const groupBy = grouping.some((groupOptions) => !!groupOptions[altShape])
    ? altShape
    : 'default';

  return grouping.reduce((accumulator, group) => {
    if (group[groupBy]) accumulator.push(group[groupBy]);
    return accumulator;
  }, []);
};

const getTilePattern = function ({ tilePattern = {} }, subType) {
  const path = subType && tilePattern[subType] ? subType : 'default';
  return tilePattern[path];
};

const getTileFieldPattern = function (state, path, altShape = 'default') {
  return (
    state.tileFields
      .filter((tileField) => !!tileField[altShape])
      .map((tileField) => tileField[altShape])
      .find(({ fieldBind }) => fieldBind === path) || {}
  );
};

export default {
  getSchema: (state) => state.schema || {},
  getObject: (state) => state.object || {},
  getInitObject: (state) => state.initObject || {},
  getEditObject: (state) => state.editObject || {},
  getEditInformation: (state) => state.editInformation || {},
  getOverviewBar: (state) => state.overviewBar || [],
  getDefaultObject: (state) => (ObjectArray) =>
    getDefaultObject(state, ObjectArray),
  getTitlePattern: (state) => state.titlePattern || '',
  getTilePattern: (state) => (subType) => getTilePattern(state, subType),
  getTileField: (state) => (path) => (altShape) =>
    getTileFieldPattern(state, path, altShape),
  getAreaItemPattern: (state) => (area) =>
    state.areaPattern.find(({ areaType }) => areaType === area) || {},
  getAreaPattern: (state) => state.areaPattern || [],
  getAreaField: (state) => (field) => getAreaField(state, field) || {},
  getAvailableAreas: (state) => state.availableAreas || [],
  getSuggestions:
    (state) =>
    ({ fieldBind, recordBind = '' }) =>
      state.suggestions.find((suggestion) => {
        if (recordBind) {
          return (
            suggestion.fieldBind === fieldBind &&
            suggestion.recordBind === recordBind
          );
        }
        return suggestion.fieldBind === fieldBind;
      }) || [],
  getGrouping: (state) => (altShape) => getGrouping(state, altShape),
  getLists: (state) => (listType) => (altShape) =>
    getList(state, listType, altShape),
  getViewAreas: (state) => state.viewAreas || {},
  getViewArea: (state) => (area) => getViewArea(state, area),
  getKeyField: (state) => (state.keyFields && state.keyFields.query) || '',
  getCustomSearchResults: (state) => state.search,
  getListPageSize: (state) => state.listPageSize,
  getSettings: (state) => state.settings || {},
  getProgressBar: (state) => state.progressBar || [],
  getSearchAutoSuggest: (state) => (field) =>
    state.searchAutoSuggest.find(
      ({ recordBind, fieldBind }) =>
        recordBind === field.recordBind && fieldBind === field.fieldBind,
    ) || {},
  getTexts: (state) => state.texts || [],
  getAttachments: (state) => state.attachments || [],
  getExpSearch: (state) => state.expSearch || {},
};
